"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NavigationService = function NavigationService($state) {
  "ngInject";

  var go = function go(to) {
    return $state.go(to);
  };

  var isCurrent = function isCurrent(page) {
    return $state.is(page);
  };

  return { go: go, isCurrent: isCurrent };
};

exports.default = NavigationService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/navigation.service.js
 **/